import { toPng } from 'html-to-image';

// Captura el carnet (elemento con el id indicado, ver FormularioTarjeta) y lo descarga como PNG.
// Se usa html-to-image (copia los estilos calculados de cada elemento); html2canvas no sirve aqui:
// los estilos de MUI se insertan por CSSOM en produccion y la captura salia sin fondo ni formato.
// El fondo, la foto y el QR vienen de otros dominios (R2 y API) que envian Access-Control-Allow-Origin.
// Devuelve true si se descargo; muestra un aviso y devuelve false si no se pudo generar.
export const descargarCarnet = async (idElemento, nombreArchivo) => {
  const node = document.getElementById(idElemento);
  if (!node) return false;
  try {
    const dataUrl = await toPng(node, {
      pixelRatio: 2,
      cacheBust: true,
      backgroundColor: '#ffffff',
      skipFonts: true,
      // una <img> sin src (tarjeta sin foto) hace fallar la captura
      filter: (n) => !(n.tagName === 'IMG' && !n.getAttribute('src')),
    });
    const link = document.createElement('a');
    link.download = `${nombreArchivo}.png`;
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } catch (error) {
    console.error(error);
    alert('No se pudo generar la imagen del carnet. Inténtalo nuevamente.');
    return false;
  }
};
